import { NavLink } from "react-router-dom";
// imports images
import socialMediaImg from "../assets/image/socialMedia.gif";
import LoginFrom from "./LoginFrom";
/*--------------import auth0--------------*/
import { useAuth0 } from "@auth0/auth0-react";
export default function Login() {
  const { loginWithRedirect } = useAuth0();
  return (
    <>
      <div className="card card0 border-0">
        <div className="row d-flex">
          <div className="col-lg-6">
            <div className="card1 pb-5">
              <div className="row">
                <img
                  src={socialMediaImg}
                  alt="socialMediaImg"
                  className="logo socialMedia"
                  style={{ height: "10rem", width: "12rem" }}
                />
              </div>
              <div className="row px-3 justify-content-center mt-4 mb-5 border-line">
                <img
                  src="https://i.imgur.com/uNGdWHi.png"
                  alt="factoryImg"
                  className="image factory"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="card2 card border-0 px-4 py-5">
              <div className="row mb-4 px-3">
                <h2 className="mb-0 mr-4 mt-2" style={{ fontWeight: "600" }}>
                  Sign in with
                </h2>
                <div
                  className="facebook text-center mr-3"
                  style={{ marginTop: "1rem", marginRight: "0.5rem",backgroundColor:"black",color:"#fff"}}
                  onClick={() => {
                    loginWithRedirect();
                  }}
                >
                  <div className="fa fa-google"></div>
                </div>
                <div
                  className="facebook text-center mr-3"
                  style={{ marginTop: "1rem", marginRight: "0.5rem" }}
                  onClick={() => {
                    loginWithRedirect();
                  }}
                >
                  <div className="fa fa-facebook"></div>
                </div>
                <div
                  className="twitter text-center mr-3"
                  style={{ marginTop: "1rem", marginRight: "0.5rem" }}
                  onClick={() => {
                    loginWithRedirect();
                  }}
                >
                  <div className="fa fa-twitter"></div>
                </div>
                <div
                  className="facebook text-center mr-3"
                  style={{
                    marginTop: "1rem",
                    marginRight: "0.5rem",
                    backgroundColor: "black",
                  }}
                  onClick={() => {
                    loginWithRedirect();
                  }}
                >
                  <div
                    className="fa fa-github"
                    style={{
                      fontSize: "3rem",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  ></div>
                </div>
                <div
                  className="linkedin text-center mr-3"
                  style={{ marginTop: "1rem" }}
                  onClick={() => {
                    loginWithRedirect();
                  }}
                >
                  <div className="fa fa-linkedin"></div>
                </div>
              </div>
              <div className="row px-3 mb-4">
                <div className="line"></div>
                <small className="or text-center">Or</small>
                <div className="line"></div>
              </div>

              <LoginFrom />

              <div className="row mb-4 px-3">
                <small className="font-weight-bold">
                  Don't have an account?
                  <NavLink className="text-danger" to="/reg">
                    Sign up
                  </NavLink>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
